var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"pic",attrs:{"src":require("../assets/2ef139de7f2e95fcd2dcd879eb9d3ce.png"),"alt":""}})])}]

export { render, staticRenderFns }